export default "__VITE_ASSET__Bhrc6GXe__"